import { render, staticRenderFns } from "./StockItemsList.vue?vue&type=template&id=6b82141e&"
import script from "./StockItemsList.vue?vue&type=script&lang=js&"
export * from "./StockItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports